export const NO_CACHE = 'no-cache';
